import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './IndustryIndividualCard.css';

export default class IndustriesIndustryCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
			{ this.props.clickable ?
				<Link className="i_industries_link" to={this.props.link} onClick={this.props.click} >
		  			<div className="i_industry_content_card">
		  				<div className="i_industry_content_card_image" style={{backgroundImage: `url(${this.props.image})`}}></div>
		  				<div className="i_industry_content_card_text">
		  					<div className="i_industry_content_card_title">{this.props.title}</div>
		  					<hr className="i_industry_content_card_break"/>
		  					<div className="i_industry_content_card_description"><span>{this.props.description1}</span></div>
		  					{this.props.description2 && <div className="i_industry_content_card_description"><span>{this.props.description2}</span></div>}
		  					{this.props.description3 && <div className="i_industry_content_card_description"><span>{this.props.description3}</span></div>}
		  					{this.props.description4 && <div className="i_industry_content_card_description"><span>{this.props.description4}</span></div>}
		  				</div>
		  				{this.props.moreEnabled && <div className="i_industry_content_card_more">FIND OUT MORE</div>}
		  			</div>
  				</Link> :
				<Link className="i_industries_link_disabled" to={this.props.link} onClick={(event) => event.preventDefault()} >
		  			<div className="i_industry_content_card">
		  				<div className="i_industry_content_card_image" style={{backgroundImage: `url(${this.props.image})`}}></div>
		  				<div className="i_industry_content_card_text">
		  					<div className="i_industry_content_card_title">{this.props.title}</div>
		  					<hr className="i_industry_content_card_break"/>
		  					<div className="i_industry_content_card_description"><span>{this.props.description1}</span></div>
		  					{this.props.description2 && <div className="i_industry_content_card_description"><span>{this.props.description2}</span></div>}
		  					{this.props.description3 && <div className="i_industry_content_card_description"><span>{this.props.description3}</span></div>}
		  					{this.props.description4 && <div className="i_industry_content_card_description"><span>{this.props.description4}</span></div>}
		  				</div>
		  				{this.props.moreEnabled && <div className="i_industry_content_card_more">FIND OUT MORE</div>}
		  			</div>
  				</Link>
			}
			</div>
		)
	}
};
